import * as React from "react";
export const IconArrowRightGray = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={props?.size || 32}
		height={props?.size || 32}
		fill="none"
		className="ic-arrow-right-gray"
		{...props}
	>
		<path
			fill={props?.color || "#A8A8A8"}
			d="M24.5 16.686c0-.491-.187-.983-.562-1.358L12.144 3.535A1.92 1.92 0 1 0 9.428 6.25l10.435 10.435L9.428 27.121a1.92 1.92 0 0 0 2.717 2.716l11.793-11.793c.375-.375.562-.866.562-1.358Z"
		/>
	</svg>
);
